// extracted by mini-css-extract-plugin
export default {"container":"PromotionsTab_container__hg3h2","btnChange":"PromotionsTab_btnChange__c0GCc"};